import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "components/shared/inputs/Select";
import type { FilterConfig } from "components/shared/filters/Filters/types";
import { STATUS_CONFIG } from "./columns";
import { DEPARTMENTS, UNITS, type WindowStatus } from "./data";

const STATUSES = Object.keys(STATUS_CONFIG) as WindowStatus[];

export const useSelfSchedulingFilters = (): FilterConfig[] => {
    const { t } = useTranslation();

    return useMemo(() => [
        {
            name: "name",
            label: t("name"),
            type: "text",
        },
        {
            name: "department",
            label: t("department"),
            type: "select",
            component: (
                <Select>
                    {DEPARTMENTS.map((department) => (
                        <Select.Item key={department} value={department}>
                            {department}
                        </Select.Item>
                    ))}
                </Select>
            ),
        },
        {
            name: "unit",
            label: t("unit"),
            type: "select",
            component: (
                <Select>
                    {UNITS.map((unit) => (
                        <Select.Item key={unit} value={unit}>
                            {unit}
                        </Select.Item>
                    ))}
                </Select>
            ),
        },
        {
            name: "status",
            label: t("status"),
            type: "select",
            component: (
                <Select>
                    {STATUSES.map((status) => (
                        <Select.Item key={status} value={status}>
                            {t(STATUS_CONFIG[status].label)}
                        </Select.Item>
                    ))}
                </Select>
            ),
        },
    ], [t]);
};
